import { useParams } from "react-router-dom";
import { TextMessageList } from "@/business-settings/text-messages/text-message-list";
import { useGetOutboundTextMessages } from "@/text-messages/query";

export const OutboundMessages = () => {
  const { businessId } = useParams();
  const {
    data: outboundMessages,
    isLoading,
    isError,
    refetch,
  } = useGetOutboundTextMessages(businessId);

  return (
    <TextMessageList
      textMessages={outboundMessages}
      isLoading={isLoading}
      isError={isError}
      onRetry={() => void refetch()}
      emptyMessage="No outbound messages yet"
    />
  );
};
